import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  FormText,
  FormFeedback,
  Label,
  Table,
  Input,
  Button,
  Row,
  Col,
  Spinner,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem
} from 'reactstrap';
import Select from 'react-select';
import Skeleton from 'react-loading-skeleton';
import { ApiService } from '../../../constants';
import { HttpService } from '../../../utilities';
import Swal from 'sweetalert2';
import { DateTime } from '../../../components/datetime';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  approve,
  detailEvaluation,
  getMasterQuestionEvaluation,
  postEvaluation,
  reject
} from '../../../services/selfreport-evaluation';
import { showNotification } from '../../../utilities/mantineNotification';
import FacilitatorModal from '../../event/event/FacilitatorModal';
import AdminLayout from '../../../components/layout/admin';
import PageHeaderWrapper from '../../../components/page_header_wrapper';
import HelmetTitle from '../../../components/helmet_title/HelmetTitle';
import moment from 'moment';

const DetailEvaluationSharingSession = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});

  const [selfReportAsOptions, setSelfReportAsOptions] = useState<any>([]);
  const [selfReportAsSelected, setSelfReportAsSelected] = useState<any>(null);
  const [programTypeOptions, setProgramTypeOptions] = useState<any>([]);
  const [programTypeSelected, setProgramTypeSelected] = useState<any>(null);
  const [showModalFacilitator, setShowModalFacilitator] =
    useState<boolean>(false);

  const handleFacilitatorData = (rows) => {
    let newObj = { ...data };
    if (newObj.facilitators && newObj.facilitators.length > 0) {
      for (const ix in rows) {
        let found = false;
        if (!rows[ix]['keyId'] || rows[ix]['keyId'] == '') {
          rows[ix]['keyId'] =
            (rows[ix].id || '') + '-' + (rows[ix].facilitatorId || '');
        }
        for (const ij in newObj.facilitators) {
          if (newObj.facilitators[ij].keyId == rows[ix].keyId) {
            found = true;
            newObj.facilitators[ij] = rows[ix];
            break;
          }
        }
        if (!found) {
          newObj.facilitators.push(rows[ix]);
        }
      }
    } else {
      newObj.facilitators = rows;
    }
    setData(newObj);
  };

  // ========>>>>>> START SELF REPORT ENHANCEMENT <<<<<==========
  const [dataResponse, setDataResponse] = useState<any>([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [sessionTitle, setSessionTitle] = useState('');
  const [sessionStart, setSessionStart] = useState('');
  const [sessionEnd, setSessionEnd] = useState('');
  const [learningDelivery, setLearningDelivery] = useState(null);
  const [feedbackContent, setFeedbackContent] = useState('');
  const [feedbackFacilitator, setFeedbackFacilitator] = useState('');
  const [feedbackFacility, setFeedbackFacility] = useState('');
  const [facilitatorSelected, setFacilitatorSelected] = useState(null);
  const [notes, setNotes] = useState('');
  const [approvedAt, setApprovedAt] = useState('');
  const [approvedBy, setApprovedBy] = useState('');
  const [duration, setDuration] = useState('');
  const [userRoleOptions, setUserRoleOptions] = useState<any>([
    { value: '999', label: 'Sharing Session' }
  ]);
  const [userRoleSelected, setUserRoleSelected] =
    useState<any>('Sharing Session');
  const [reportAs, setReportAs] = useState('Participant');

  const [listLearningMethod, setListLearningMethod] = useState([
    { value: '001', label: 'Face to Face' },
    { value: '002', label: 'Online' },
    { value: '003', label: 'Blended' }
  ]);
  const [facilitatorList, setFacilitatorList] = useState([]);
  const [status, setStatus] = useState('');
  const [selectedQuestionEvaluation, setSelectedQuestionEvaluation] = useState(
    []
  );

  const fetchedMasterQuestion = useQuery({
    queryKey: [`masterQuestion`],
    queryFn: () => getMasterQuestionEvaluation(),
    enabled: true
  });

  const getUserData: any = () => {
    const jsonString = localStorage.getItem('persist:root');
    const object = JSON.parse(jsonString);
    return JSON.parse(object.auth).userData;
  };

  const _userData = getUserData();

  useEffect(() => {
    if (props.match.params.id === null) {
      props.history.push('/home');
    }
    if (selfReportAsSelected) {
      console.log(selfReportAsSelected.value);
      if (selfReportAsSelected.value === '001') {
        const _userData = getUserData();
        // if (_userData && !_userData.isTeacher) {
        if (!userRoleOptions.find((it) => it.value === '999')) {
          setUserRoleOptions([
            ...userRoleOptions,
            { value: '999', label: 'Sharing Session' }
          ]);
        }
        // }
      }
    }
    const payload = {
      id: props.match.params.id
    };
    detailData.mutate(payload);
  }, [selfReportAsSelected]);

  const detailData = useMutation({
    mutationFn: detailEvaluation,
    onSuccess: (response) => {
      if (response?.data?.resultCode === 200) {
        const data = response?.data?.data;
        setDataResponse(data);
        setSessionTitle(data.trainingName);
        setSessionStart(data.sessionStart);
        setSessionEnd(data.sessionEnd);

        setFeedbackContent(data.feedbackContent);
        setFeedbackFacilitator(data.feedbackFacilitator);
        setFeedbackFacility(data.feedbackFacility);
        setFacilitatorList(data.facilitators);
        setStatus(data.status);
        setNotes(data.notes);
        setApprovedAt(data.approvedAt);
        setApprovedBy(data.approvedBy);
        setDuration(data.duration);
        setSelectedQuestionEvaluation(data.evaluation);
        if (data.evaluation[0].type === 'online') {
          setLearningDelivery({ value: '002', label: 'Online' });
        } else if (data.evaluation[0].type === 'facetoface') {
          setLearningDelivery({ value: '001', label: 'Face to Face' });
        } else {
          setLearningDelivery({ value: '003', label: 'Blended' });
        }
      } else {
        showNotification({
          type: 'error',
          title: 'Oh no! something wrong when saved your self report',
          message:
            response?.data?.errorMessage ||
            'Failed when save self report. Please try again'
        });
      }
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const handleApproved = (e) => {
    if (!notes) {
      showNotification({
        type: 'error',
        title: 'Notes is required',
        message: 'Please fill the notes before approve/reject'
      });
      return;
    }
    e.preventDefault();
    Swal.fire({
      title: 'Question',
      text: 'Do you want to approve this sharing session?',
      showCancelButton: true,
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          selfReportId: props.match.params.id,
          binusianId: _userData.binusianId,
          notes: notes
        };
        approveReview.mutate(payload);
      }
    });
  };

  const handleCancel = (e) => {
    e.preventDefault();
    //  go back window
    props.history.goBack();
  };

  const handleReject = (e) => {
    if (!notes) {
      showNotification({
        type: 'error',
        title: 'Notes is required',
        message: 'Please fill the notes before approve/reject'
      });
      return;
    }
    e.preventDefault();
    Swal.fire({
      title: 'Question',
      text: 'Do you want to reject this sharing session?',
      showCancelButton: true,
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          selfReportId: props.match.params.id,
          binusianId: _userData.binusianId,
          notes: notes
        };
        rejectReview.mutate(payload);
      }
    });
  };

  const rejectReview = useMutation({
    mutationFn: reject,
    onSuccess: (response) => {
      if (response?.data?.resultCode === 200) {
        showNotification({
          type: 'success',
          title: 'Yeay! sharing session has been rejected',
          message: 'Please give feedback to the facilitator personally'
        });
        props.history.push('/management/bcld-review');
      } else {
        showNotification({
          type: 'error',
          title: 'Oh no! something wrong when saved your self report',
          message:
            response?.data?.errorMessage ||
            'Failed when save self report. Please try again'
        });
      }
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const approveReview = useMutation({
    mutationFn: approve,
    onSuccess: (response) => {
      if (response?.data?.resultCode === 200) {
        showNotification({
          type: 'success',
          title: 'Yeay! sharing session has been approved',
          message:
            "Please don't forget to give feedback to the facilitator personally"
        });
        props.history.push('/management/bcld-review');
      } else {
        showNotification({
          type: 'error',
          title: 'Oh no! something wrong when processing self report',
          message:
            response?.data?.errorMessage ||
            'Failed when save self report. Please try again'
        });
      }
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  //====================================
  //==== Render Component
  //====================================
  const renderRequestorInformation = () => {
    return (
      <>
        <hr className="my-4" />
        <h5 className="font-weight-bold">Requestor Information</h5>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Binusian ID</Label>
              <Input
                name="binusianId"
                value={dataResponse.binusianId || ''}
                placeholder="Binusian ID"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Name</Label>
              <Input
                name="fullName"
                value={dataResponse.fullName || ''}
                placeholder="Fullname"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Division / BU</Label>
              <Input
                name="division"
                value={
                  dataResponse.businessUnitName ||
                  dataResponse.divisionName ||
                  ''
                }
                placeholder="Division"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Department / Major</Label>
              <Input
                name="department"
                value={dataResponse.department || ''}
                placeholder="Department"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Position</Label>
              <Input
                name="position"
                value={dataResponse.position || ''}
                placeholder="Position"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Email</Label>
              <Input
                name="Email"
                value={dataResponse.email || ''}
                placeholder="Email"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
        </Row>
        <hr className="my-4" />
      </>
    );
  };

  // ========>>>>>> END SELF REPORT ENHANCEMENT <<<<<==========

  const handleShowFacilitatorModal = (e) => {
    e.preventDefault();
    setShowModalFacilitator(!showModalFacilitator);
  };

  const handleDeleteFacilitator = (e, row, _index) => {
    e.preventDefault();
    const newObj = JSON.parse(JSON.stringify(data));
    const oldfacilitators = newObj.facilitators;
    newObj.facilitators = oldfacilitators.filter((it, idx) => {
      return idx != _index;
    });
    setData(newObj);
  };

  const renderFacilitator = () => {
    return (
      <>
        {/* <FacilitatorModal
          selectedfacilitators={facilitatorList}
          showModal={showModalFacilitator}
          handleData={handleFacilitatorData}
          toggleModal={handleShowFacilitatorModal}
        /> */}
        <h5 className="font-weight-bold required">Facilitators</h5>

        <Table striped>
          <thead>
            <tr>
              <th>Facilitator Name</th>
              <th>Facilitator Institution</th>
              <th>Facilitator Email</th>
              {/* <th className="action-col">Action</th> */}
            </tr>
          </thead>
          <tbody>
            {facilitatorList &&
              facilitatorList.map((row, i) => {
                return (
                  <tr key={i}>
                    <td>{row.facilitatorName}</td>
                    <td>{row.facilitatorInstitution}</td>
                    <td>{row.facilitatorEmail}</td>
                    {/* <td width="10%">
                      <a
                        href="#"
                        onClick={(e) => handleDeleteFacilitator(e, row, i)}
                        className="mr-2"
                      >
                        <i className="fa fa-trash"></i>
                      </a>
                    </td> */}
                  </tr>
                );
              })}
          </tbody>
        </Table>
        {/* <Button
          type="button"
          color="warning"
          size="lg"
          className="mb-4"
          onClick={handleShowFacilitatorModal}
        >
          Add Facilitator
        </Button> */}
      </>
    );
  };

  return (
    <AdminLayout>
      <PageHeaderWrapper>
        <HelmetTitle title="Self Report Review" />
        <Breadcrumb>
          <BreadcrumbItem active>Self Report Review</BreadcrumbItem>
        </Breadcrumb>
      </PageHeaderWrapper>
      <Card>
        <CardBody>
          {/* <h4 className="status-name">Status : { data.statusName || '-' }</h4> */}
          {!loading ? (
            <Form>
              <form>
                <FormGroup>
                  <Label className="required">Self Report As</Label>
                  <Input
                    value={reportAs || ''}
                    placeholder=""
                    required
                    type="text"
                    disabled={true}
                  />
                </FormGroup>
                <FormGroup>
                  <Label className="required">Program Type</Label>
                  <Input
                    value={userRoleSelected || ''}
                    required
                    type="text"
                    disabled={true}
                  />
                </FormGroup>
                {renderRequestorInformation()}
                {/* <hr className="my-4" /> */}
                <h5 className="font-weight-bold">Training Information</h5>
                <FormGroup>
                  <Label className="required">Session Title</Label>
                  <Input
                    name="sessionTitle"
                    value={sessionTitle || ''}
                    placeholder="Session Title"
                    onChange={(e) => setSessionTitle(e.target.value)}
                    required
                    type="text"
                    disabled={true}
                  />
                </FormGroup>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label className="required">Session Start Date</Label>
                      <Input
                        name="trainingStartTime"
                        value={formatDate(sessionStart)}
                        placeholder="Start Date & Time"
                        type="text"
                        disabled={true}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label className="required">Session End Date</Label>

                      <Input
                        name="trainingEndTime"
                        value={formatDate(sessionEnd)}
                        placeholder="End Date & Time"
                        type="text"
                        disabled={true}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label className="required">Duration</Label>

                      <Input
                        name="duration"
                        value={duration}
                        type="text"
                        disabled={true}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {renderFacilitator()}
                {/* <FormGroup>
                <Label className="required">Learning Delivery Method</Label>
                <Select
                  name="learningDeliveryMethod"
                  value={learningDelivery || ''}
                  onChange={(e) => setLearningDelivery(e)}
                  options={listLearningMethod}
                />
              </FormGroup> */}
                {learningDelivery && (
                  <>
                    <hr className="my-4" />
                    <h5 className="font-weight-bold">
                      {learningDelivery.value == '003'
                        ? 'Blended Training Evaluation'
                        : learningDelivery.value === '002'
                        ? 'Online Training Evaluation'
                        : 'Face to Face Training Evaluation'}
                    </h5>
                    <div
                      style={{
                        marginBottom: '20px'
                      }}
                    >
                      <p>
                        Kami menghargai evaluasi Anda terhadap pelatihan ini dan
                        mohon bantuan Anda untuk melengkapi form ini. Dalam
                        skala 1-6, mohon mengisi nomor yang sesuai dengan
                        pendapat Anda terhadap setiap pertanyaan.
                      </p>
                      <i
                        style={{
                          color: 'gray'
                        }}
                      >
                        We value your evaluation regarding this training and
                        would need your help to complete the form. On a scale of
                        1-6, please fill in the number that indicates your
                        opinion on each statement.
                      </i>
                    </div>
                    {Array.isArray(selectedQuestionEvaluation) &&
                      selectedQuestionEvaluation.map((item, index) => (
                        <FormGroup key={index}>
                          <div
                            style={{
                              display: 'flex',
                              marginBottom: '10px'
                            }}
                          >
                            <div
                              style={{
                                marginRight: '10px'
                              }}
                            >
                              <Label>{index + 1}.</Label>
                            </div>
                            <div
                              style={{
                                display: 'table-column'
                              }}
                            >
                              <div>
                                <Label>{item.translate}</Label>
                              </div>
                              <div>
                                <i
                                  style={{
                                    color: 'gray'
                                  }}
                                >
                                  {item.question}
                                </i>
                              </div>
                            </div>
                          </div>
                          <Row form>
                            {Array.from({ length: 6 }, (_, i) => i + 1).map(
                              (value) => (
                                <Col md={2} key={value}>
                                  <FormGroup check>
                                    <Label check>
                                      <Input
                                        type="radio"
                                        name={`question-${index}`}
                                        value={value}
                                        disabled={true}
                                        checked={item.answer === value}
                                        onChange={() => {
                                          setSelectedQuestionEvaluation(
                                            (currentEvaluation) =>
                                              currentEvaluation.map(
                                                (evalItem, evalIndex) =>
                                                  evalIndex === index
                                                    ? {
                                                        ...evalItem,
                                                        answer: value
                                                      }
                                                    : evalItem
                                              )
                                          );
                                        }}
                                      />
                                      {value === 1
                                        ? 'Strongly Disagree'
                                        : value === 2
                                        ? 'Disagree'
                                        : value === 3
                                        ? 'Slighly Disagree'
                                        : value === 4
                                        ? 'Slighly Agree'
                                        : value === 5
                                        ? 'Agree'
                                        : 'Strongly Agree'}
                                    </Label>
                                  </FormGroup>
                                </Col>
                              )
                            )}
                          </Row>
                        </FormGroup>
                      ))}
                  </>
                )}
                <hr className="my-4" />
                <FormGroup>
                  <Label>Feedback Content</Label>
                  <Input
                    name="isiContent"
                    value={feedbackContent || ''}
                    placeholder="Feedback Content"
                    onChange={(e) => {
                      setFeedbackContent(e.target.value);
                    }}
                    disabled={true}
                    rows="4"
                    type="textarea"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Feedback Facilitator</Label>
                  <Input
                    name="isiFacilitator"
                    value={feedbackFacilitator || ''}
                    placeholder="Feedback Facilitator"
                    onChange={(e) => {
                      setFeedbackFacilitator(e.target.value);
                    }}
                    disabled={true}
                    rows="4"
                    type="textarea"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Feedback Facility</Label>
                  <Input
                    name="isiFacility"
                    value={feedbackFacility || ''}
                    placeholder="Feedback Facility"
                    onChange={(e) => {
                      setFeedbackFacility(e.target.value);
                    }}
                    disabled={true}
                    rows="4"
                    type="textarea"
                  />
                </FormGroup>
                {notes !== '' ? (
                  <FormGroup>
                    <Label>BCL&D Notes</Label>
                    <Input
                      required
                      name="notes"
                      disabled={status === '001' ? false : true}
                      value={notes || ''}
                      placeholder="Notes"
                      onChange={(e) => {
                        setNotes(e.target.value);
                      }}
                      rows="4"
                      type="textarea"
                    />
                  </FormGroup>
                ) : null}

                {status === '001' ? null : (
                  <Label style={{ fontWeight: 'bold', color: '#7B2183' }}>
                    {status === '002' ? 'Approved' : 'Rejected'} by {approvedBy}{' '}
                    {moment(approvedAt).format('DD MMM YYYY HH:mm')}
                  </Label>
                )}
                <Row className="mt-5 justify-content-md-center">
                  <Col md={2}>
                    <Button
                      block
                      size="lg"
                      onClick={handleCancel}
                      disabled={loading}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </form>
            </Form>
          ) : (
            <Skeleton count={4} />
          )}
        </CardBody>
      </Card>
    </AdminLayout>
  );
};

function formatDate(date: string | number | Date): string {
  if (!date) {
    return '';
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return '';
  }
  // Format the date components
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');

  // Construct the formatted date string in "DD/MM/YYYY hh:mm" format
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export default DetailEvaluationSharingSession;
